var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 152.958,
    height: 152.957,
    viewBox: "0 0 152.958 152.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_1",
    "data-name": "Exclusion 1",
    d: "M76.48,152.957A76.5,76.5,0,0,1,46.71,6.01a76.5,76.5,0,0,1,59.538,140.937A76,76,0,0,1,76.48,152.957ZM42.771,70.06a6.418,6.418,0,0,0-4.583,10.92l23.693,24.08a6.384,6.384,0,0,0,4.579,1.92.921.921,0,0,1,.128.006,6.458,6.458,0,0,0,4.625-2.106l43.728-48.16a6.422,6.422,0,0,0-9.5-8.639L66.276,91.215,47.345,71.977A6.363,6.363,0,0,0,42.771,70.06Z",
    fill: "#05b4ef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.d0c9822703ad168cb345a41d06d5fe34.svg";
export { ForwardRef as ReactComponent };